import { ChangeDetectorRef, Component, Input, OnDestroy, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { StylesMenuItemComponent } from '@brafton/angular-styles-library';
import { BfAuthService } from '@brafton/skynet-angular-security-service';

@Component({
  selector: 'shared-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SharedSideMenuComponent implements OnDestroy {
  @Input() appVersion?: any;
  @Input() mobileQuery?: MediaQueryList;
  @ViewChild('drawer') sidenav!: MatDrawer;
  private mobileQueryListener: () => void;

  @ViewChildren('homeChildren') homeChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('projectsChildren') projectsChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('organizationChildren') organizationChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('campaignChildren') campaignChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('sowChildren') sowChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('editorialMenuChildren') editorialMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('designMenuChildren') designMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('videoMenuChildren') videoMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('socialMenuChildren') socialMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('consultingMenuChildren') consultingMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('techMenuChildren') techMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('contentChildren') contentChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('dataProcessingMenuChildren') dataProcessingMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('emailMenuChildren') emailMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('ppcMenuChildren') ppcMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('seoMenuChildren') seoMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('uxMenuChildren') uxMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('salesOpsMenuChildren') salesOpsMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('projectManagementMenuChildren') projectManagementMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('accountManagementMenuChildren') accountManagementMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;
  @ViewChildren('salesMenuChildren') salesMenuChildrenQuery?: QueryList<StylesMenuItemComponent>;



  constructor(private changeDetectorRef: ChangeDetectorRef, public auth: BfAuthService) {
    this.mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery?.addEventListener('change', this.mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery?.removeEventListener('change', this.mobileQueryListener);
  }





}
